import * as yup from 'yup';

import demographicsFields from 'features/consults/shared/tabs/Demographics/formFields';
import { requiredString } from 'utils/constants';
import { EegConsultTypes } from 'utils/enums';

export default yup.object().shape({
  [demographicsFields.firstName.name]: yup
    .string()
    .trim()
    .required(requiredString),
  [demographicsFields.lastName.name]: yup
    .string()
    .trim()
    .required(requiredString),
  [demographicsFields.age.name]: yup
    .string()
    .trim()
    .matches(/^[1-9]\d*$/, 'Invalid age'),
  [demographicsFields.facility.name]: yup
    .number()
    .nullable()
    .required(requiredString),
  [demographicsFields.consultType.name]: yup
    .string()
    .trim()
    .required(requiredString),
  [demographicsFields.observationType.name]: yup
    .string()
    .nullable()
    .when(
      ['consultType', 'eegPediatricConsultType'],
      ([consultType, eegPediatricConsultType], schema) => {
        const selectedConsultType = consultType ?? eegPediatricConsultType;
        const requiresObservation = [
          EegConsultTypes.CEEG,
          EegConsultTypes.POINT_OF_CARE_EEG,
          EegConsultTypes.CERIBELL,
          EegConsultTypes.ZETO,
        ].includes(selectedConsultType);

        return requiresObservation
          ? schema.required(requiredString)
          : schema.notRequired();
      },
    ),
});
